import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import CapsuleAccordion from 'src/app/components/Elements/Accordion';
import { DefaultPhoneNumber } from 'src/app/components/Elements/Location';
import { useLazySegmentTrack } from 'src/app/hooks/useLazySegmentTrack';
import { useSegmentTrack } from 'src/app/hooks/useSegmentTrack';
import type { RenderedAccordionQuestions } from 'src/app/types';
import { CAPSULE_HELP_EMAIL } from 'src/consts';

import questions from './faq';
import { PrecedingSpan } from './styles';

const FaqPage = ({ expandCallback, loggedIn, dispatchSegmentTrack }) => {
  useSegmentTrack(UNIFIED.viewFaqPage);
  const [trackExpandFaq] = useLazySegmentTrack(UNIFIED.expandFaq);

  const handleExpand = (questions: RenderedAccordionQuestions, expandedIndex: [number]) => {
    /** The text inside a Fragment */
    // Expanded indexes will return an empty array when all accordions are collapsed
    if (expandedIndex?.length) {
      const text = questions[expandedIndex[0]].question.props.children;
      trackExpandFaq({ text });

      expandCallback(questions, expandedIndex[0]);
    }
  };

  const faqName = 'pages-faq';

  return (
    <main className="mx-auto max-width-6 pb-6 mb-6 px-3 mt-5 mt-md-7 wide-container-padding md-pl-6">
      <div className="px-3 blue">
        <h1 className="h3">Hello dear, need a hand?</h1>
        <div> WE&#8217;RE HERE TO HELP</div>
        <br />
        <div className="body mb-5">
          <PrecedingSpan>Call or Text:</PrecedingSpan> <DefaultPhoneNumber />
          <br />
          <PrecedingSpan>E-mail: </PrecedingSpan>
          <a href={`mailto:${CAPSULE_HELP_EMAIL}`}>{CAPSULE_HELP_EMAIL}</a>
          <br />
          <br />
        </div>
      </div>
      <div className="clearfix mb-6">
        <CapsuleAccordion
          expandCallback={handleExpand}
          expandFirstQuestion={true}
          name={faqName}
          questions={questions(loggedIn, dispatchSegmentTrack)}
        />
      </div>
    </main>
  );
};

export default FaqPage;
